// First, before anything else runs: the oldest engine we support is Chrome 74
// (Android 10's factory WebView). See polyfills.js.
import "@/polyfills";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { startInteractionLogging } from "@/lib/interactionLog";
import { startVersionWatch } from "@/lib/versionWatch";

// Before render, so errors in the first render and the very first requests are captured.
startInteractionLogging();
// A deploy reaches every open screen by itself; nobody is asked to refresh.
startVersionWatch();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

document.addEventListener("contextmenu", e => e.preventDefault());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  // The register() promise was unhandled, so every failure surfaced as an
  // uncaught rejection in the console -- one on every page load. The LAN build
  // is served under a private CA, and until `certs/ca.crt` is installed the
  // browser refuses the worker script outright ("An SSL certificate error
  // occurred when fetching the script"). That is a provisioning state, not a
  // fault: the app works without a worker, it just loses offline caching. Log
  // it once, quietly, and carry on.
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(err => {
      console.info("Service worker not registered; offline caching is off.", err?.message || err);
    });
  });
}

